import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Grid } from "@mui/material";
import { IoClose } from "react-icons/io5";
import FrontCreditoIcon from "../../../assets/navbar/Front_Credito_on_light_blue.svg";
import Table from "../../../pages/ViewCreditProposal/subcomponents/Table";

import {
  CardWrapper,
  Label,
  Header,
  BoxUser,
  Image,
  Description,
  Title,
  PopupBackground,
  PopupContainer,
  TitleCloseBtn,
} from "../../../pages/ViewCreditProposal/detail/styles";
import { formatCPF } from "../../../utils/formats";
import Input from "../../../pages/ViewCreditProposal/detail/Input";
import api from "../../../services/api";
import { toast } from "react-toastify";

const HistoryModal = (props) => {
  const { open, onClose, numeroProposta, cpfCnpj, nomeCliente } = props;

  const style = {
    justify: "center",
  };

  const loadData = async (url) => {
    return api
      .get(url)
      .then((response) => {
        if (response && (response.status === 201 || response.status === 200)) {
          return response.data;
        }
        if (!response) {
          toast.error("Erro ao buscar os dados.");
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Erro ao buscar os dados.");
        }
      });
  };

  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    loadData(
      `/api/front-credito/historico-proposta?numeroProposta=${numeroProposta}`
    )
      .then((data) => {
        setRows(data);
        setIsLoading(false);
      })
      .catch((err) => {
        setRows([]);
      });
  }, [numeroProposta]);

  const columns = [
    { id: "dataHoraInclusao", name: "Data/Hora", style },
    { id: "descricaoStatus", name: "Descrição do Status", style },
    { id: "nomeUsuarioTransfEntrada", name: "Usuário", style },
    { id: "observacoesTransferencia", name: "Observações", style },
    { id: "situacaoStatus", name: "Situação", style },
  ];

  return (
    <PopupBackground>
      <PopupContainer>
        <TitleCloseBtn>
          <button onClick={onClose}>
            <IoClose />
          </button>
        </TitleCloseBtn>
        <Header>
          <BoxUser>
            <Image src={FrontCreditoIcon} />
            <div>
              <Title>Front de Crédito</Title>
              <Description>Histórico</Description>
            </div>
          </BoxUser>
        </Header>
        <CardWrapper>
          <Label>Registros do Históricos</Label>

          <Card>
            <Grid container spacing={3}>
              <Grid item xs={12} md={3}>
                <Input
                  disabled
                  color="#f6f6f6"
                  label="Proposta"
                  loading={loading}
                  value={numeroProposta}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Input
                  disabled
                  color="#f6f6f6"
                  label="CPF/CNPJ"
                  loading={loading}
                  value={formatCPF(cpfCnpj)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Input
                  disabled
                  label="Nome do cliente"
                  align="flex-start"
                  type="textarea"
                  loading={loading}
                  value={nomeCliente}
                />
              </Grid>
            </Grid>

            <div>&nbsp;</div>
            <div
              style={{ width: "100%", height: "45vh", "overflow-x": "auto" }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Table
                    loading={isLoading}
                    noDataMessage="SEM DADOS."
                    entries={rows}
                    columns={columns}
                  />
                </Grid>
              </Grid>
            </div>
          </Card>
        </CardWrapper>
      </PopupContainer>
    </PopupBackground>
  );
};

export const Card = styled.div`
  padding: 21px 19px 26.4px 20px;
  border-radius: 6px;
  border: solid 1px #b9b9ba;
`;

export default HistoryModal;
